var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 29,
    viewBox: "0 0 21 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0803 0C4.52205 0 0 4.52205 0 10.0803C0 15.555 6.19662 24.0681 8.87777 27.4954C9.49796 28.2881 10.6713 28.2809 11.2823 27.481C13.9484 23.9904 20.1605 15.2974 20.1605 10.0803C20.1605 4.52205 15.6387 0 10.0803 0ZM13.1217 13.0318C12.2831 13.8702 11.1817 14.2895 10.0803 14.2895C8.97896 14.2895 7.8773 13.8702 7.03901 13.0318C5.36192 11.3549 5.36192 8.62619 7.03901 6.9491C7.8511 6.13666 8.93134 5.6892 10.0803 5.6892C11.2292 5.6892 12.3092 6.13683 13.1217 6.9491C14.7988 8.62619 14.7988 11.3549 13.1217 13.0318Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/Icon-Location.47cf7afcd7624a5789610e8616ca9786.svg";
export { ForwardRef as ReactComponent };